import React, { useRef, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MiniSpinner } from '../../layouts/Spinner';
import {
    setPage,
    goPage,
    sendEmail,
    reSendEmail,
    getPdf,
} from '../../../redux/actions/quotation/quotation.actions';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { globalDropDown } from '../../../redux/actions/helper/helper.actions';
import DropDownAttachFileGlobal from '../../layouts/DropDownAttachFile.global.js';
import QuotationCustomTemplate from '../custom_template/QuotationCustomTemplate';

function QuotationModalPrint({
    single_quotation,
    mini_loading,
    print_modal_qu,
    setPage,
    onHide,
    download_pdf,
    edit_url,
    goPage,
    new_uploads,
    files_to_remove,
    globalDropDown,
    subs_setting,
    sendEmail,
    sending_email,
    reSendEmail,
    getPdf,
    auth,
}) {
    const componentRef = useRef();

    // drawer + notes state
    const [showNotes, setShowNotes] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [noteText, setNoteText] = useState('');
    /**
     * notes shape:
     * {
     *   id: string
     *   message: string
     *   createdAt: string | Date
     *   createdBy: string
     * }
     */
    const [notes, setNotes] = useState([]);

    // ---- INTERNAL NOTES MAPPING ----
    useEffect(() => {
        if (
            single_quotation &&
            Array.isArray(single_quotation.internal_notes)
        ) {
            const mapped = single_quotation.internal_notes.map((n, idx) => {
                const createdAtRaw =
                    n.created_at && n.created_at.$date
                        ? n.created_at.$date
                        : n.created_at;

                return {
                    id: n._id || `${single_quotation._id}-${idx}`,
                    message: n.message || '',
                    createdAt: createdAtRaw || null,
                    createdBy: n.created_by || '',
                };
            });

            setNotes(mapped);
            setShowNotes(mapped.length > 0);
            setIsAdding(false);
        } else {
            setNotes([]);
            setShowNotes(false);
            setIsAdding(false);
        }
    }, [single_quotation]);

    const status_lbl = (
        <span className={`lbl-status mr-1 lbl-${single_quotation.status}`}>
            {single_quotation.status}
        </span>
    );

    // previous button
    const previousBtn = (
        <>
            {single_quotation.latest_quotation_no !==
                single_quotation.quotation_no && (
                <div className="mdl-arrow-left arr-link">
                    <Link onClick={() => goPage('prev')}>
                        <i className="la la-angle-left mdl-arrow"></i>
                    </Link>
                </div>
            )}
        </>
    );

    // next button
    const nextBtn = (
        <>
            {single_quotation.oldest_quotation_no !==
                single_quotation.quotation_no && (
                <div className="mdl-arrow-right arr-link">
                    <Link onClick={() => goPage('next')}>
                        <i className="la la-angle-right mdl-arrow"></i>
                    </Link>
                </div>
            )}
        </>
    );

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const toggleNotes = () => {
        setShowNotes((prev) => !prev);
        setIsAdding(false);
    };

    const handleStartAdd = () => {
        setIsAdding(true);
    };

    const handleCancelAdd = () => {
        setIsAdding(false);
        setNoteText('');
    };

    const handleAddNote = () => {
        const trimmed = noteText.trim();
        if (!trimmed) return;

        const createdBy =
            (auth &&
                auth.user &&
                (auth.user.fullname || auth.user.name || auth.user.email)) ||
            single_quotation.user_prepared_by ||
            'You';

        const newNote = {
            id: `new-${Date.now()}`,
            message: trimmed,
            createdAt: new Date().toISOString(),
            createdBy,
        };

        const updated = [...notes, newNote];
        setNotes(updated);
        setNoteText('');
        setIsAdding(false);

        // TODO: dispatch action to persist updated notes to backend, e.g.:
        // updateQuotationInternalNotes(single_quotation._id, updated);
    };

    const handleRemoveNote = (id) => {
        const updated = notes.filter((n) => n.id !== id);
        setNotes(updated);
        // TODO: persist to backend if needed
    };

    const formatDate = (value) => {
        if (!value) return '';
        try {
            const d = new Date(value);
            if (Number.isNaN(d.getTime())) return '';
            return d.toLocaleDateString();
        } catch {
            return '';
        }
    };

    let file_counter =
        (single_quotation.uploads ? single_quotation.uploads.length : 0) +
        new_uploads.length -
        files_to_remove.length;

    return (
        <Modal
            centered
            dialogClassName="modal-wdth"
            show={print_modal_qu}
            onHide={() => setPage('print_modal_qu', null, false)}
            size={showNotes ? 'xl' : 'lg'}
            animation={true}
        >
            <Modal.Header className="inv-bg-header">
                <div className="col-4 pl-0">
                    <div className="modal-status">{status_lbl}</div>
                </div>
                <div className="col-8 pr-0">
                    <div className="float-right">
                        <Link
                            to={`${edit_url}/${single_quotation._id}`}
                            className="btn btn-circle btn-inv btn-grey mr-1 icon-edit-c"
                        >
                            <i className="ft ft-edit cursor-pointer"></i>
                        </Link>

                        <button
                            onClick={(e) => globalDropDown(e, 'show')}
                            className="btn btn-circle btn-inv btn-grey mr-1 icon-paper-c relative"
                        >
                            <i className="ft ft-paperclip cursor-pointer"></i>
                            {file_counter > 0 ? (
                                <span className="badge badge-pill badge-sm badge-danger badge-up badge-file">
                                    {file_counter > 9 ? '9+' : file_counter}
                                </span>
                            ) : (
                                <></>
                            )}
                        </button>

                        <DropDownAttachFileGlobal
                            origin="quotation"
                            origin_data={single_quotation}
                            new_uploads={new_uploads}
                            files_to_remove={files_to_remove}
                        />

                        {single_quotation.email_sent ? (
                            <button
                                className="btn btn-circle btn-inv btn-grey mr-1"
                                onClick={(e) =>
                                    reSendEmail(e, single_quotation._id)
                                }
                            >
                                <i
                                    className={
                                        sending_email
                                            ? 'icon-loading-custom icon-20 cursor-pointer'
                                            : 'ft-custom-mail-check cursor-pointer'
                                    }
                                ></i>
                            </button>
                        ) : (
                            <button
                                className="btn btn-circle btn-inv btn-grey mr-1"
                                onClick={(e) =>
                                    sendEmail(e, single_quotation._id)
                                }
                            >
                                <i
                                    className={
                                        sending_email
                                            ? 'icon-loading-custom icon-20 cursor-pointer'
                                            : 'ft-custom-mail-x cursor-pointer'
                                    }
                                ></i>
                            </button>
                        )}

                        <button
                            className="btn btn-circle btn-inv btn-grey mr-1 icon-pdf-c"
                            onClick={(e) =>
                                getPdf(
                                    e,
                                    single_quotation._id,
                                    single_quotation.quotation_no,
                                    single_quotation.customer.name
                                )
                            }
                        >
                            <i
                                className={
                                    download_pdf
                                        ? 'icon-loading-custom icon-20 cursor-pointer'
                                        : 'la la-file-pdf-o cursor-pointer'
                                }
                            ></i>
                        </button>

                        <button
                            onClick={handlePrint}
                            className="btn btn-circle btn-inv btn-grey mr-1"
                        >
                            <i className="ft ft-printer cursor-pointer"></i>
                        </button>

                        {/* optional manual toggle, but drawer already auto-opens if notes exist */}
                        <button
                            onClick={toggleNotes}
                            className="btn btn-circle btn-inv btn-grey mr-1"
                        >
                            <i className="ft ft-message-square cursor-pointer"></i>
                        </button>

                        <button
                            onClick={() =>
                                setPage('print_modal_qu', null, false)
                            }
                            className="btn btn-circle btn-inv m-close-btn cursor-pointer"
                        >
                            <i className="ft ft-x cursor-pointer"></i>
                        </button>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="unset-scroll p-0 m-0">
                <div className="sd-border modal-container">
                    <div className="modal-main">
                        {previousBtn}
                        {mini_loading ? (
                            <div className="my-5">
                                <MiniSpinner />
                            </div>
                        ) : (
                            <QuotationCustomTemplate
                                componentRef={componentRef}
                            />
                        )}
                        {nextBtn}
                    </div>

                    {showNotes && (
                        <div className="internal-notes-panel">
                            <div className="internal-notes-header">
                                <span>Internal Notes</span>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light"
                                    onClick={toggleNotes}
                                >
                                    <i className="ft ft-x" />
                                </button>
                            </div>

                            <div className="internal-notes-content">
                                {isAdding && (
                                    <div className="internal-notes-form mb-3">
                                        <textarea
                                            className="form-control mb-2"
                                            rows="3"
                                            value={noteText}
                                            onChange={(e) =>
                                                setNoteText(e.target.value)
                                            }
                                            placeholder="Type internal note here..."
                                        />
                                        <div className="d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-secondary mr-2"
                                                onClick={handleCancelAdd}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-primary"
                                                onClick={handleAddNote}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {notes.length === 0 && !isAdding && (
                                    <p className="text-muted f-12">
                                        No internal notes yet.
                                    </p>
                                )}

                                {notes.map((note) => (
                                    <div
                                        key={note.id}
                                        className="note-card mb-3"
                                    >
                                        <div className="note-card-header">
                                            <div className="note-user-icon">
                                                <i className="ft ft-user" />
                                            </div>
                                            <div className="note-user-meta">
                                                <div className="note-user-name">
                                                    {note.createdBy || '—'}
                                                </div>
                                                <div className="note-date">
                                                    {formatDate(note.createdAt)}
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-link btn-sm p-0 ml-auto"
                                                onClick={() =>
                                                    handleRemoveNote(note.id)
                                                }
                                            >
                                                <i className="ft ft-trash-2" />
                                            </button>
                                        </div>
                                        <div className="note-body">
                                            {note.message}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* {!isAdding && (
                                <button
                                    type="button"
                                    className="internal-notes-plus-btn"
                                    onClick={handleStartAdd}
                                >
                                    <span>+</span>
                                </button>
                            )} */}
                        </div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    single_quotation: state.quotation.single_quotation,
    print_modal_qu: state.quotation.print_modal_qu,
    mini_loading: state.quotation.mini_loading,
    new_uploads: state.quotation.new_uploads,
    files_to_remove: state.quotation.files_to_remove,
    subs_setting: state.quotation.subs_setting,
    sending_email: state.quotation.sending_email,
    download_pdf: state.quotation.download_pdf,
    auth: state.auth,
});

export default connect(mapStateToProps, {
    setPage,
    goPage,
    globalDropDown,
    sendEmail,
    reSendEmail,
    getPdf,
})(QuotationModalPrint);
